module.exports = __webpack_public_path__ + "0-a96bf992.worker.js"